import React from 'react';
import CustomerMyBusinessByCustomerDetail from './CustomerMyBusinessByCustomerDetail';
import { CRM_COMM_PAGE_ALL_ACQUISITION_BY_CUSTOMER_DETAIL_ACQUISITIONS } from '../../utils/crmCommunicationTableColumns';

export default function CustomerAllAcquisitionByCustomerDetail(props) {
  return (
    <CustomerMyBusinessByCustomerDetail
      {...props}
      adminMode
      mode="acquisitions"
      listEndpointBase="/api/customer_evaluations/all_acquisitions/by_customer"
      detailEndpointPrefix="/api/customer_evaluations/my_customers"
      embeddedListPageKey={CRM_COMM_PAGE_ALL_ACQUISITION_BY_CUSTOMER_DETAIL_ACQUISITIONS}
    />
  );
}
